import { render } from "./reportHos.vue?vue&type=template&id=625e95ec&scoped=true"
import script from "./reportHos.vue?vue&type=script&lang=js"
export * from "./reportHos.vue?vue&type=script&lang=js"

import "./reportHos.vue?vue&type=style&index=0&id=625e95ec&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625e95ec"]])

export default __exports__